export default __webpack_public_path__ + "static/media/netflixone.0d0bbc96.png";